import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { FilterIcon } from "ui/gluestack/icon";
import { View } from "react-native";

interface FilterButtonProps {
  onPress: () => void;
  hasFilters: boolean;
}

export function FilterButton({ onPress, hasFilters }: FilterButtonProps) {
  return (
    <Button variant="outline" onPress={onPress}>
      <ButtonIcon as={FilterIcon} />
      <ButtonText className="hidden sm:flex">Filter</ButtonText>
      {hasFilters ? (
        <View className="absolute left-7 bottom-2 w-2.5 h-2.5 bg-red-500 rounded-full"></View>
      ) : null}
    </Button>
  );
}
